<!-- Main content container -->
<main class="compound-content">
  <!-- Studio Viewer (Map) - Always present, controlled by visibility -->
  <app-compound-map-display [class.d-none]="(searchQueryService.searchDisplayMode$ | async) !== SearchDisplayMode.MAP"
                            [aiAgents]="agents"></app-compound-map-display>

  <!-- Grid Display Component -->
  <app-compound-grid-display *ngIf="(searchQueryService.searchDisplayMode$ | async) === SearchDisplayMode.GRID"></app-compound-grid-display>

  @if ((flagService.getFlags$() | async)?.[FeatureFlags.AI_AGENTS]){
  <!-- Property Analyst Panel — independent session, fixed agent -->
  <app-compound-property-analyst-display
    *ngIf="(searchQueryService.searchDisplayMode$ | async) === SearchDisplayMode.PROPERTY"
    [agentId]="propertyAgentId"
    [agentLabel]="propertyAgentLabel"
    [agents]="propertyAgents()"
    (close)="onPropertyChatClose()">
  </app-compound-property-analyst-display>
  }
    @if ((flagService.getFlags$() | async)?.[FeatureFlags.AI_AGENTS]){
        <!-- AI Assistant Display Component -->
        <app-compound-ai-view-display
                *ngIf="(searchQueryService.searchDisplayMode$ | async) === SearchDisplayMode.AI"
                [agentId]="activeAgent()?.id ?? ''"
                [agentLabel]="activeAgent()?.label ?? 'AI Assistant'"
                [idleConfig]="activeAgent()?.idleState"
                [toolRenderers]="toolRenderers"
                (close)="onAiChatClose()">
        </app-compound-ai-view-display>
    }

</main>


